import {
  Box,
  CloseButton,
  Dialog,
  Heading,
  Link,
  Portal,
  Text,
} from "@chakra-ui/react";
import PalommaLogoWithText from "./PalommaLogoWithText";

type Props = {
  open: boolean;
  errorCode: number | null;
  onClose: () => void;
  onResendClick: () => void;
};

const LoginModal = ({
  open,
  errorCode,
  onClose,
  onResendClick,
}: Props): JSX.Element => {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(e) => !e.open && onClose()}
      size={"md"}
      placement="center"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <CloseButton
              position="absolute"
              top={2}
              right={2}
              onClick={onClose}
            />
            <Dialog.Body>
              <Box
                padding={"3rem 2rem 2rem 2rem"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"center"}
                minHeight={"17.8125rem"}
              >
                <Box display={"flex"} flexDirection={"column"} gap={"2rem"}>
                  {errorCode ? (
                    <LoginError errorCode={errorCode} />
                  ) : (
                    <LoginSuccess onClick={onResendClick} />
                  )}
                </Box>
                <PalommaLogoWithText height={120} width={120} />
              </Box>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

const LoginError = ({ errorCode }: { errorCode: number }): JSX.Element => {
  return (
    <Box textAlign={"center"}>
      <Text fontSize={"1.375rem"} fontWeight={500} mb={"1rem"}>
        ¡Oops! Algo salió mal.
      </Text>
      <Text fontWeight={400} maxW={"20rem"}>
        {errorCode === 404
          ? "El correo electrónico ingresado no está registrado. Para registrarte, contacta al equipo Palomma."
          : "Ha ocurrido un error inesperado. Intenta nuevamente y si el problema persiste, contacta al equipo Palomma."}
      </Text>
    </Box>
  );
};

const LoginSuccess = ({ onClick }: { onClick: () => void }): JSX.Element => {
  return (
    <>
      <Box textAlign={"center"} gap={"1rem"}>
        <Heading size="2xl">Se ha enviado un link de ingreso</Heading>
        <Text fontWeight={400}>
          Ingresa a tu correo para entrar a la plataforma desde el enlace, si es
          necesario revisa tu carpeta de spam.
        </Text>
      </Box>
      <Box display="flex" justifyContent="center" justifyItems="center" gap={4}>
        <Text>¿No puedes ingresar?</Text>
        <Link fontWeight={600} color={"#4012AB"} onClick={onClick}>
          Volver a enviar correo
        </Link>
      </Box>
    </>
  );
};

export default LoginModal;
